import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["entries", "entry"]

  connect() {
    this.draggedElement = null
    this.dragOverElement = null
  }

  addEntry(event) {
    event.preventDefault()
    const url = event.params.url

    fetch(url)
      .then(response => response.text())
      .then(html => {
        this.entriesTarget.insertAdjacentHTML('beforeend', html)
      })
  }

  removeEntry(event) {
    event.preventDefault()
    event.target.closest('[data-score-timeline-editor-target="entry"]').remove()
  }

  dragStart(event) {
    // Don't start drag if clicking on button or input
    if (event.target.tagName === 'BUTTON' || event.target.tagName === 'INPUT' || event.target.closest('button, input')) {
      event.preventDefault()
      return false
    }
    
    // Find the entry element (could be currentTarget or parent)
    const entry = event.currentTarget.hasAttribute('data-score-timeline-editor-target') 
      ? event.currentTarget 
      : event.currentTarget.closest('[data-score-timeline-editor-target="entry"]')
    
    if (!entry) return
    
    this.draggedElement = entry
    entry.classList.add('opacity-50', 'cursor-grabbing')
    event.dataTransfer.effectAllowed = 'move'
    event.dataTransfer.setData('text/html', entry)
  }

  dragEnd(event) {
    const entry = event.currentTarget.hasAttribute('data-score-timeline-editor-target')
      ? event.currentTarget
      : event.currentTarget.closest('[data-score-timeline-editor-target="entry"]')
    
    if (entry) {
      entry.classList.remove('opacity-50', 'cursor-grabbing')
    }
    
    // Remove drag over styling from all entries
    this.entryTargets.forEach(entry => {
      entry.classList.remove('border-indigo-500', 'ring-2', 'ring-indigo-500')
    })
    
    this.draggedElement = null
    this.dragOverElement = null
  }

  dragOver(event) {
    event.preventDefault()
    event.dataTransfer.dropEffect = 'move'

    const entry = event.currentTarget
    if (entry === this.draggedElement || entry === this.dragOverElement) {
      return
    }

    // Remove styling from previous drag over element
    if (this.dragOverElement) {
      this.dragOverElement.classList.remove('border-indigo-500', 'ring-2', 'ring-indigo-500')
    }

    // Add styling to current drag over element
    entry.classList.add('border-indigo-500', 'ring-2', 'ring-indigo-500')
    this.dragOverElement = entry
  }

  dragLeave(event) {
    // Only remove styling if we're leaving the element (not entering a child)
    if (!event.currentTarget.contains(event.relatedTarget)) {
      event.currentTarget.classList.remove('border-indigo-500', 'ring-2', 'ring-indigo-500')
      this.dragOverElement = null
    }
  }

  drop(event) {
    event.preventDefault()
    
    if (!this.draggedElement || this.draggedElement === event.currentTarget) {
      return
    }

    const dropTarget = event.currentTarget
    const draggedIndex = Array.from(this.entriesTarget.children).indexOf(this.draggedElement)
    const dropIndex = Array.from(this.entriesTarget.children).indexOf(dropTarget)

    if (draggedIndex < dropIndex) {
      this.entriesTarget.insertBefore(this.draggedElement, dropTarget.nextSibling)
    } else {
      this.entriesTarget.insertBefore(this.draggedElement, dropTarget)
    }

    // Clean up styling
    dropTarget.classList.remove('border-indigo-500', 'ring-2', 'ring-indigo-500')
    this.draggedElement = null
    this.dragOverElement = null
  }
}
